var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProviderVideoOff = function SvgProviderVideoOff(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M35.829 20.655v-9.196c0-1.547-1.88-2.33-2.975-1.235l-3.984 3.999V8.138c0-.956-.783-1.738-1.74-1.738h-9.759l15.5 15.489c1.079 1.095 2.958.313 2.958-1.234zM3.777.51c-.693.68-.693 1.781 0 2.462L7.37 6.518H6.07c-.978 0-1.778.786-1.778 1.746v17.463c0 .96.8 1.746 1.778 1.746h21.341c.374 0 .694-.14.978-.314l4.41 4.33c.694.681 1.815.681 2.508 0 .694-.68.694-1.781 0-2.462L6.285.511C5.59-.17 4.47-.17 3.777.51z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProviderVideoOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/provider-video-off.e74939d939766652c3d22d1b4ee4421d.svg";